import { render, staticRenderFns } from "./emergencyResponse.vue?vue&type=template&id=fc87ea82&scoped=true&"
import script from "./emergencyResponse.vue?vue&type=script&lang=js&"
export * from "./emergencyResponse.vue?vue&type=script&lang=js&"
import style0 from "./emergencyResponse.vue?vue&type=style&index=0&id=fc87ea82&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc87ea82",
  null
  
)

export default component.exports